export const ToDebtSmsTypes = {
  GET_DEBT_RESIDENT: "GET_DEBT_RESIDENT",
  SEND_SMS_PREVIEW: "SEND_SMS_PREVIEW",
  SEND_SMS_DEBT: "SEND_SMS_DEBT",
}